import React from 'react';
import PropTypes from 'prop-types';
import LetterSection from '../LetterSection';
import styles from './styles.module.styl';

const Terms = ({ letters, termsByLetter }) => (
  <section>
    {(letters.length === 0) && <p className={styles.noResults}>
      No results
    </p>}

    {letters.map(letter =>
      <LetterSection letter={letter} terms={termsByLetter[letter]} />
    )}
  </section>
);

Terms.propTypes = {
  letters: PropTypes.array.isRequired,
  termsByLetter: PropTypes.object.isRequired
};

Terms.defaultProps = {
  letters: []
};

export default Terms;
